import React, { Component } from 'react';
import { Table, Button } from 'reactstrap';
import './CommissionsList.css';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { sharedLabelsPath } from "../../../reducers/common/localization";
import { Link } from "react-router-dom";
import { Redirect } from "react-router-dom";
import PaginationCommissions from "../../commonComponents/paginationComponent/PaginationCommissions.container";
import RemoveCommissionModal from "../commissionsModal/removeCommissionModal/RemoveCommissionModal.container";
import { Utils } from '../../../utils/utils';
import Select from '../../commonComponents/customSelect/CustomSelect.container';

class CommissionsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCommissionBAId: null,
            selectedCommissionId: null
        }
    }

    render() {
        if (!_.isNil(this.state.selectedCommissionId) && !_.isNil(this.state.selectedCommissionBAId)) {
            return <Redirect to={"/edit-commission?baId=" + this.state.selectedCommissionBAId + "&id=" + this.state.selectedCommissionId} push />
        }

        return (
            <div className='commissions-list-component-container'>
                <div className='commissions-list-container'>
                    <h4 className='page-label'>{_.get(this.props.translation, 'commissions.commissions_list_label')}</h4>
                    <PaginationCommissions />
                    <div className="top-pane-container">
                        {this.renderFilters()}
                        <div className='add-commission-button-container'>
                            <Button
                                tag={Link}
                                to="/add-commission"
                                className='add-commission-button olive-green-btn'
                            >
                                {_.get(this.props.translation, sharedLabelsPath.add_button)}
                            </Button>
                        </div>
                    </div>
                    {this.renderContent()}
                </div>
                <RemoveCommissionModal />
            </div>
        )
    }

    renderContent() {
        if (this.props.loading) {
            return (
                <div className="commissions-list-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="commissions-list-status-message-container">
                    <h5>{_.get(this.props.translation, 'commissions.no_data_label')}</h5>
                </div>
            );
        }
        return (
            <Table className='commissions-list-table'>
                <thead>
                    <tr>
                        <th>{_.get(this.props.translation, sharedLabelsPath.name_label)}</th>
                        <th>{_.get(this.props.translation, sharedLabelsPath.continent_label)}</th>
                        <th>{_.get(this.props.translation, 'commissions.countries_label')}</th>
                        <th>{_.get(this.props.translation, 'commissions.commission_label')}</th>
                        <th>{_.get(this.props.translation, 'commissions.date_from_label')}</th>
                        <th>{_.get(this.props.translation, 'commissions.date_to_label')}</th>
                        <th />
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {this.renderCommissionsData()}
                </tbody>
            </Table>
        )
    }

    renderCommissionsData() {
        return _.map(this.props.data, (data, index) => (
            <tr key={index} className="commission-row" onClick={this.handleRowClick(data.baId, data.id)}>
                <td className='name-td' data-th={_.get(this.props.translation, sharedLabelsPath.name_label) + ':'}>
                    {data.name}
                </td>
                <td className='continent-td'
                    data-th={_.get(this.props.translation, sharedLabelsPath.continent_label) + ':'}>
                    {_.get(this.props.translation, 'continents.' + data.continent)}
                </td>
                <td className='countries-td'
                    data-th={_.get(this.props.translation, 'commissions.countries_label') + ':'}>
                    <div className="countries-container">
                        {
                            _.map(data.countries, (country, id) => {
                                return (
                                    <div className="country-item" key={id}>
                                        {_.get(this.props.translation, 'countries.' + country)}
                                    </div>
                                )
                            })
                        }
                    </div>
                </td>
                <td className='commission-td'
                    data-th={_.get(this.props.translation, 'commissions.commission_label') + ':'}>
                    {data.commission + '%'}
                </td>
                <td className='date-from-td'
                    data-th={_.get(this.props.translation, 'commissions.date_from_label') + ':'}>
                    {data.dateFrom}
                </td>
                <td className='date-to-td' data-th={_.get(this.props.translation, 'commissions.date_to_label') + ':'}>
                    {data.dateTo}
                </td>
                <td className='edit-commission-cell'>
                    <IconContainer
                        key={index}
                        icon='create'
                        className='commissions-list-create-icon'
                        title={_.get(this.props.translation, sharedLabelsPath.edit_button)}
                    />
                </td>
                <td className='delete-commission-cell'>
                    <IconContainer
                        key={index}
                        icon="trash"
                        className="commissions-list-delete-icon"
                        onClick={this.onRemoveButtonClick(data.id)}
                        title={_.get(this.props.translation, sharedLabelsPath.remove_button)}
                    />
                </td>
            </tr>
        ))
    }

    handleRowClick = (baId, id) => () => {
        this.setState({ 
            selectedCommissionBAId: baId,
            selectedCommissionId: id
        });
    };

    componentDidMount() {
        this.props.onMount();
    }
    
    componentWillUnmount() {
        this.props.onUnmount();
    }

    onAddButtonClick = () => {
        this.setState({ redirect: true });
    };

    onRemoveButtonClick = (id) => (e) => {
        e.stopPropagation();
        this.props.onCommissionRemove(id);
    };

    renderFilters = () => {
        let BAsOptions = [
            { value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label) },
            ...Utils.getBAsOptions(this.props.BAsList)
        ];

        let continentsOptions = [
            { value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label) },
            ...Utils.getLocationOptions(
                this.props.continents,
                _.get(this.props.translation, sharedLabelsPath.continents)
            )
        ];

        let countriesOptions = [
            { value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label) },
            ...Utils.getLocationOptions(
                this.props.countries,
                _.get(this.props.translation, sharedLabelsPath.countries)
            )
        ];

        return (
            <div className="filters-container">
                <h6 className="filters-title">{_.get(this.props.translation, sharedLabelsPath.filter_options_label) + ":"}</h6>
                <div className="ba-filter-container">
                    <h6>{_.get(this.props.translation, 'commissions.ba_short_label')}</h6>
                    <Select
                        className="ba-filter-select"
                        selectedOption={_.find(BAsOptions, option => option.value === this.props.BAFilter)}
                        options={BAsOptions}
                        onSelect={this.handleChangeBASelect}
                    />
                </div>
                <div className="continent-filter-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.continent_label)}</h6>
                    <Select
                        className="continent-filter-select"
                        selectedOption={_.find(continentsOptions, option => option.value === this.props.continentCode || (_.isEmpty(option.value) && _.isEmpty(this.props.continentCode)))}
                        options={continentsOptions}
                        onSelect={this.handleChangeContinentSelect}
                    />
                </div>
                <div className="country-filter-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.country_label)}</h6>
                    <Select
                        className="country-filter-select"
                        selectedOption={_.find(countriesOptions, option => option.value === this.props.countryFilter)}
                        options={countriesOptions}
                        onSelect={this.handleChangeCountrySelect}
                    />
                </div>
            </div>
        )
    }

    handleChangeContinentSelect = (selectedOption) => {
        this.props.onSetContinent(selectedOption.value);
        this.props.onCountryFilterChange(null);
    };

    handleChangeCountrySelect = (selectedOption) => {
        this.props.onCountryFilterChange(selectedOption.value);
    }

    handleChangeBASelect = (selectedOption) => {
        this.props.onBAFilterChange(selectedOption.value);
    };
}

const CommissionShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    continent: PropTypes.string.isRequired,
    countries: PropTypes.arrayOf(PropTypes.string).isRequired,
    commission: PropTypes.number.isRequired,
    dateFrom: PropTypes.string.isRequired,
    dateTo: PropTypes.string.isRequired,
});

CommissionsList.propTypes = {
    loading: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    data: PropTypes.arrayOf(CommissionShape),
    continentCode: PropTypes.string,
    continents: PropTypes.array,
    countries: PropTypes.array,
    BAsList: PropTypes.array,
    BAFilter: PropTypes.string,
    onMount: PropTypes.func,
    onCommissionRemove: PropTypes.func,
    onSetContinent: PropTypes.func,
    onCountryFilterChange: PropTypes.func,
    onBAFilterChange: PropTypes.func,
    onUnmount: PropTypes.func,
};

export default CommissionsList;



// WEBPACK FOOTER //
// ./src/components/paymentManagement/commissionsList/CommissionsList.js